import { Typography } from 'modules/Typography';
export function AvatarListHeader(props) {
    const { title } = props;
    return (<Typography $fontSize="small" $fontWeight="semibold">
      {title}
    </Typography>);
}
